/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowPerformer } from './ShowPerformer';
import {
    ShowPerformerFromJSON,
    ShowPerformerFromJSONTyped,
    ShowPerformerToJSON,
    ShowPerformerToJSONTyped,
} from './ShowPerformer';
import type { ShowTypeEnum } from './ShowTypeEnum';
import {
    ShowTypeEnumFromJSON,
    ShowTypeEnumFromJSONTyped,
    ShowTypeEnumToJSON,
    ShowTypeEnumToJSONTyped,
} from './ShowTypeEnum';
import type { ShowStage } from './ShowStage';
import {
    ShowStageFromJSON,
    ShowStageFromJSONTyped,
    ShowStageToJSON,
    ShowStageToJSONTyped,
} from './ShowStage';
import type { Status02dEnum } from './Status02dEnum';
import {
    Status02dEnumFromJSON,
    Status02dEnumFromJSONTyped,
    Status02dEnumToJSON,
    Status02dEnumToJSONTyped,
} from './Status02dEnum';

/**
 * Show serializer with nested relationships.
 * Show is aggregate/rollup of Hold data.
 * @export
 * @interface Show
 */
export interface Show {
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    description?: string;
    /**
     * 
     * @type {ShowTypeEnum}
     * @memberof Show
     */
    showType?: ShowTypeEnum;
    /**
     * 
     * @type {Status02dEnum}
     * @memberof Show
     */
    status?: Status02dEnum;
    /**
     * Show date - null for tentative shows until confirmed
     * @type {Date}
     * @memberof Show
     */
    showDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    doorsTime?: string | null;
    /**
     * Preferred show time - null for tentative shows
     * @type {string}
     * @memberof Show
     */
    showTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    endTime?: string | null;
    /**
     * Actual attendance count
     * @type {number}
     * @memberof Show
     */
    readonly attendance: number | null;
    /**
     * Total ticket sales
     * @type {string}
     * @memberof Show
     */
    readonly ticketRevenue: string | null;
    /**
     * Bar/concessions revenue
     * @type {string}
     * @memberof Show
     */
    readonly barRevenue: string | null;
    /**
     * Merchandise, parking, etc.
     * @type {string}
     * @memberof Show
     */
    readonly otherRevenue: string | null;
    /**
     * Production, staffing, etc.
     * @type {string}
     * @memberof Show
     */
    readonly totalExpenses: string | null;
    /**
     * Default performer deal type for this show.
     * @type {string}
     * @memberof Show
     */
    performerDealType?: string | null;
    /**
     * Who the configured door deal percentage belongs to.
     * @type {string}
     * @memberof Show
     */
    doorDealPercentageOwner?: string | null;
    /**
     * Configured split percentage for the selected owner (optional).
     * @type {string}
     * @memberof Show
     */
    doorDealPercentage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly totalRevenue: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly netProfit: string;
    /**
     * 
     * @type {boolean}
     * @memberof Show
     */
    readonly isSettled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    readonly settlementDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    settlementNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    notes?: string;
    /**
     * Team that created/manages this show
     * @type {number}
     * @memberof Show
     */
    team?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly teamName: string;
    /**
     * 
     * @type {boolean}
     * @memberof Show
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    readonly createdBy: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Array<ShowStage>}
     * @memberof Show
     */
    readonly showStages: Array<ShowStage>;
    /**
     * 
     * @type {Array<ShowPerformer>}
     * @memberof Show
     */
    readonly showPerformers: Array<ShowPerformer>;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly venue: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly holdBreakdown: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly holdCount: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    readonly dateRange: string;
}



/**
 * Check if a given object implements the Show interface.
 */
export function instanceOfShow(value: object): value is Show {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('attendance' in value) || value['attendance'] === undefined) return false;
    if (!('ticketRevenue' in value) || value['ticketRevenue'] === undefined) return false;
    if (!('barRevenue' in value) || value['barRevenue'] === undefined) return false;
    if (!('otherRevenue' in value) || value['otherRevenue'] === undefined) return false;
    if (!('totalExpenses' in value) || value['totalExpenses'] === undefined) return false;
    if (!('totalRevenue' in value) || value['totalRevenue'] === undefined) return false;
    if (!('netProfit' in value) || value['netProfit'] === undefined) return false;
    if (!('isSettled' in value) || value['isSettled'] === undefined) return false;
    if (!('settlementDate' in value) || value['settlementDate'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('showStages' in value) || value['showStages'] === undefined) return false;
    if (!('showPerformers' in value) || value['showPerformers'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('holdBreakdown' in value) || value['holdBreakdown'] === undefined) return false;
    if (!('holdCount' in value) || value['holdCount'] === undefined) return false;
    if (!('dateRange' in value) || value['dateRange'] === undefined) return false;
    return true;
}

export function ShowFromJSON(json: any): Show {
    return ShowFromJSONTyped(json, false);
}

export function ShowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Show {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'showType': json['show_type'] == null ? undefined : ShowTypeEnumFromJSON(json['show_type']),
        'status': json['status'] == null ? undefined : Status02dEnumFromJSON(json['status']),
        'showDate': json['show_date'] == null ? undefined : (new Date(json['show_date'])),
        'doorsTime': json['doors_time'] == null ? undefined : json['doors_time'],
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'endTime': json['end_time'] == null ? undefined : json['end_time'],
        'attendance': json['attendance'],
        'ticketRevenue': json['ticket_revenue'],
        'barRevenue': json['bar_revenue'],
        'otherRevenue': json['other_revenue'],
        'totalExpenses': json['total_expenses'],
        'performerDealType': json['performer_deal_type'] == null ? undefined : json['performer_deal_type'],
        'doorDealPercentageOwner': json['door_deal_percentage_owner'] == null ? undefined : json['door_deal_percentage_owner'],
        'doorDealPercentage': json['door_deal_percentage'] == null ? undefined : json['door_deal_percentage'],
        'totalRevenue': json['total_revenue'],
        'netProfit': json['net_profit'],
        'isSettled': json['is_settled'],
        'settlementDate': (json['settlement_date'] == null ? null : new Date(json['settlement_date'])),
        'settlementNotes': json['settlement_notes'] == null ? undefined : json['settlement_notes'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'team': json['team'] == null ? undefined : json['team'],
        'teamName': json['team_name'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdBy': json['created_by'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'showStages': ((json['show_stages'] as Array<any>).map(ShowStageFromJSON)),
        'showPerformers': ((json['show_performers'] as Array<any>).map(ShowPerformerFromJSON)),
        'venue': json['venue'],
        'holdBreakdown': json['hold_breakdown'],
        'holdCount': json['hold_count'],
        'dateRange': json['date_range'],
    };
}

  export function ShowToJSON(json: any): Show {
      return ShowToJSONTyped(json, false);
  }

  export function ShowToJSONTyped(value?: Omit<Show, 'id'|'attendance'|'ticket_revenue'|'bar_revenue'|'other_revenue'|'total_expenses'|'total_revenue'|'net_profit'|'is_settled'|'settlement_date'|'team_name'|'created_by'|'created_at'|'updated_at'|'show_stages'|'show_performers'|'venue'|'hold_breakdown'|'hold_count'|'date_range'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'show_type': ShowTypeEnumToJSON(value['showType']),
        'status': Status02dEnumToJSON(value['status']),
        'show_date': value['showDate'] == null ? undefined : ((value['showDate'] as any).toISOString().substring(0,10)),
        'doors_time': value['doorsTime'],
        'show_time': value['showTime'],
        'end_time': value['endTime'],
        'performer_deal_type': value['performerDealType'],
        'door_deal_percentage_owner': value['doorDealPercentageOwner'],
        'door_deal_percentage': value['doorDealPercentage'],
        'settlement_notes': value['settlementNotes'],
        'notes': value['notes'],
        'team': value['team'],
        'is_active': value['isActive'],
    };
}

